const applicationReducer = (state = {}, action) => {
    switch (action.type) {
      case "ADD_APPLICATION": {
        return{
          ...state,
          applicationSuccess: action.success
        }
      }
      case "ADD_APPLICATION_ERR": {
        return{
          ...state,
          applicationError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default applicationReducer;
  